import React, { useState, useRef } from "react";
import { createPortal } from 'react-dom';
import "./AGENTASSISTPOPUP.css";

const FilterDropdown = ({ values, selected, onChange, placeholder = "Filter" }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [tempSelected, setTempSelected] = useState(new Set());

  const visibleValues = values.filter((v) => String(v).toLowerCase().includes(query.trim().toLowerCase()));

  const toggleValue = (v) => {
    const next = new Set(tempSelected);
    if (next.has(v)) next.delete(v);
    else next.add(v);
    setTempSelected(next);
  };

  const handleOpen = () => {
    setTempSelected(new Set(selected));
    setQuery("");
    setOpen(true);
  };

  const handleCancel = () => {
    setTempSelected(new Set(selected));
    setQuery("");
    setOpen(false);
  };

  const handleProceed = () => {
    onChange(new Set(tempSelected));
    setQuery("");
    setOpen(false);
  };

  return (
    <div className="filter-wrap">
      <button type="button" className={`filter-btn ${selected.size ? "active" : ""}`} onClick={handleOpen} title="Filter">
        {selected.size > 0 ? "✅" : "▾"}
      </button>
      {open && createPortal(
        <div className="filter-overlay">
          <div className="filter-dropdown">
            <div className="filter-actions">
              <button type="button" onClick={() => setTempSelected(new Set(visibleValues))} className="mini-btn">Select all</button>
              <button type="button" onClick={() => setTempSelected(new Set())} className="mini-btn">Clear</button>
            </div>
            <input className="filter-search" value={query} placeholder={placeholder} onChange={(e) => setQuery(e?.target?.value)} />
            <div className="filter-list">
              {visibleValues.map((v, i) => (
                <label key={i} className="packs-filter-item A3f" onClick={(e) => e.stopPropagation()}>
                  <input type="checkbox" checked={tempSelected.has(v)} onChange={(e) => { e.stopPropagation(); toggleValue(v); }} />
                  <span>{v || "(blank)"}</span>
                </label>
              ))}
            </div>
            <div className="filter-footer">
              <span className="filter-status">{tempSelected.size ? `${tempSelected.size} of ${values.length} selected` : "No filter"}</span>
              <div className="filter-buttons">
                <button type="button" className="cancel-btn" onClick={handleCancel}>Cancel</button>
                <button type="button" className="proceed-btn" onClick={handleProceed}>Proceed</button>
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </div>
  );
};

const Modal = ({ children, onClose }) => {
  const ref = useRef();
  const handleClickInside = (e) => e.stopPropagation();

  return createPortal(
    <div className="filter-overlay" onClick={onClose}>
      <div className="filter-dropdown-modal" ref={ref} onClick={handleClickInside}>
        {children}
      </div>
    </div>,
    document.body
  );
};

const AGENTASSISTPOPUP = ({ item, setErrors, index, showMaximumChat, setIsShowMaximumChat }) => {
  const [showModal, setShowModal] = useState(false);
  const [subFilters, setSubFilters] = useState({});

  const parseData = () => {
    try {
      if (!item?.data) return null;
      const parsed = JSON.parse(item.data);
      if (parsed?.isHTMLContent && parsed?.htmlScript) {
        return { isHTMLContent: true, htmlScript: parsed.htmlScript };
      }
      if (parsed?.responseContent?.table) {
        return parsed.responseContent;
      }
      return parsed;
    } catch (e) {
      console.error('Error parsing data:', e);
      return null;
    }
  };

  const data = parseData();

  const setSubFilter = (tableKey, header, setVal) => {
    const key = `${tableKey}::${header}`;
    setSubFilters((prev) => ({ ...prev, [key]: setVal }));
  };

  const getSubFilter = (tableKey, header) => {
    const key = `${tableKey}::${header}`;
    return subFilters[key] ?? new Set();
  };

  const renderChannelTable = (channelData) => {
    if (!channelData?.table) return null;
    
    const { columns, data , tableHeading } = channelData.table;
    
    const headerUniqueValues = {};
    columns.forEach((col) => {
      headerUniqueValues[col.label] = Array.from(new Set(data.map((row) => row[col.key]).filter(v => v !== undefined && v !== null && v !== '')));
    });

    const filteredRows = data.filter((row) => {
      return columns.every((col) => {
        const set = getSubFilter('channelList', col.label);
        if (!set || set.size === 0) return true;
        return set.has(row[col.key]);
      });
    });

    return (
      <div className="sub-table">
        <h4>{tableHeading}</h4>
        <div className="table-scroll">
          <table>
            <thead>
              <tr>
                {columns.map((col, idx) => (
                  <th key={idx} style={col.color ? { backgroundColor: col.color } : {}}>
                    <div className="th-inner A3f">
                      <span>{col.label}</span>
                      <FilterDropdown
                        values={headerUniqueValues[col.label]}
                        selected={getSubFilter('channelList', col.label)}
                        onChange={(setVal) => setSubFilter('channelList', col.label, setVal)}
                        placeholder={`Search ${col.label}`}
                      />
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredRows.map((row, rIdx) => (
                <tr key={rIdx}>
                  {columns.map((col, cIdx) => (
                    <td key={cIdx}>
                      {row[col.key]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="epg-button-container">
        <button className="epg-change-btn" onClick={() => {
          if (!showMaximumChat) {
            setIsShowMaximumChat(true);
          }
          setShowModal(true);
        }}>
          {item?.text || "Channel _ Old&New Price List"}
        </button>
      </div>

      {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <div className="modal-header">
            {!data?.isHTMLContent && (
              <button className="clear-filters" onClick={() => {
                const headers = data?.table?.columns?.map(col => col.label) || [];
                headers.forEach(h => setSubFilter('channelList', h, new Set()));
              }}>
                Clear All Filters
              </button>
            )}
            <button className="close-modal-btn" onClick={() => {
              const headers = data?.table?.columns?.map(col => col.label) || [];
              headers.forEach(h => setSubFilter('channelList', h, new Set()));
              setShowModal(false);
            }}>✕</button>
          </div>
          <div className="expanded-wrap">
            {data?.isHTMLContent ? (
              <div dangerouslySetInnerHTML={{ __html: data.htmlScript }} />
            ) : (
              <>
                <div className="disclaimer-container">
                  <p>
                    <span className="highlight-red">Selected filters</span> are marked with
                    <span className="highlight-bg">  Green Tick ( ✅ )</span>. To clear filters,
                    click <span className="highlight-blue">'Clear All Filters'</span> or close the window.
                  </p>
                </div>
                {renderChannelTable(data)}
              </>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default AGENTASSISTPOPUP;
